import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { MostLoginComponent } from 'src/app/shared/components/modals/most-login/most-login.component';
import { JwtService, LocalStorageService, LoginService } from '../index.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard{
  constructor(
    private jwtService:JwtService,
    private router:Router,
    private Alert: ToastrService,
    private storage:LocalStorageService,
    private matDialog:MatDialog
  ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.jwtService.destination = state.url;
    if(this.storage.getItem('token') && this.storage.getItem('identity')){
      return true;
    } else{
      if(state.url.includes('/miz') || state.url.includes('/kar')){
        this.redirectToToolsPage()
      }else{
        this.preventAccess()
      }
      return false;
    }
  }
  preventAccess(){
    this.matDialog.open(MostLoginComponent , {
      data:this.jwtService.destination
    })
  }
  redirectToToolsPage(){
    this.router.navigate(['/abzar'])
  }
}